import React, { useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { apiFetch } from "api/Api";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "assets/theme/admin_form.css";

const AddHeroSection = () => {
  const navigate = useNavigate();
  const initialState = {
    title: "",
    description: "",
    image: null,
  };

  const [formData, setFormData] = useState(initialState);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "image") {
      const file = files[0];
      setFormData({ ...formData, image: file });

      if (file) {
        setPreview(URL.createObjectURL(file));
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = new FormData();
      data.append("title", formData.title);
      data.append("description", formData.description);

      if (formData.image) {
        data.append("image", formData.image);
      }

      await apiFetch("leader_admin/add_hero_section", {
        method: "POST",
        body: data,
      });

      alert("Hero Section Added Successfully");
      navigate("/hero_section_list");

    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid mt-4" style={{ fontSize: "0.9rem" }}>

        {/* Header Card */}
        <div className="admin-form-header-card">
          <div className="d-flex align-items-center gap-3">
            <button type="button" onClick={() => navigate(-1)} className="btn-admin-back">
              <FaArrowLeft />
              <span>मागे जा (Back)</span>
            </button>
            <div>
              <h4 className="fw-bold mb-1 text-white">
                🏠 मुख्य बॅनर नोंदणी (Add Hero Banner)
              </h4>
              <small className="text-white-50">Create home hero banner slider item</small>
            </div>
          </div>

          <Link to="/hero_section_list" className="btn btn-light btn-sm fw-semibold rounded-pill px-3">
            Banner List
          </Link>
        </div>

        {/* Form Card */}
        <div className="card border-0 shadow-lg rounded-4">
          <div className="card-body p-4">

            <form onSubmit={handleSubmit}>
              <div className="row g-4">

                {/* Title */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    शीर्षक / Hero Title <span className="text-muted fw-normal">(ऐच्छिक / Optional)</span>
                  </label>
                  <input
                    type="text"
                    className="form-control shadow-sm"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                  />
                </div>

                {/* Description */}
                <div className="col-12">
                  <label className="form-label fw-semibold">
                    वर्णन / Description <span className="text-muted fw-normal">(ऐच्छिक / Optional)</span>
                  </label>
                  <textarea
                    className="form-control shadow-sm"
                    rows="4"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                  />
                </div>

                {/* Upload Image */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold d-flex align-items-center justify-content-between">
                    <span>बॅनर प्रतिमा अपलोड करा / Upload Hero Image <span className="text-danger">*</span></span>
                    <span className="badge bg-danger text-white fw-bold px-2 py-1" style={{ fontSize: "0.75rem" }}>
                      प्रतिमा आवश्यक आहे (Required *)
                    </span>
                  </label>
                  <input
                    type="file"
                    className="form-control shadow-sm"
                    name="image"
                    onChange={handleChange}
                    accept="image/*"
                    required
                  />
                  <small className="text-danger fw-semibold d-block mt-1">
                    * बॅनरसाठी प्रतिमा निवडणे बंधनकारक आहे (Image is required).
                  </small>
                </div>

                {/* Image Preview */}
                {preview && (
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      प्रतिमा पूर्वावलोकन / Image Preview
                    </label>
                    <div className="border rounded-3 p-2 shadow-sm">
                      <img
                        src={preview}
                        alt="Preview"
                        className="img-fluid rounded-3"
                      />
                    </div>
                  </div>
                )}

              </div>

              {/* Submit Button */}
              <div className="d-flex justify-content-end mt-4 pt-3 border-top">
                <button
                  className="btn btn-primary px-5 py-2 fw-semibold"
                  style={{ fontSize: "0.85rem" }}
                  disabled={loading}
                >
                  {loading ? "जतन करत आहे..." : "बॅनर जतन करा / Save Hero"}
                </button>
              </div>

            </form>

          </div>
        </div>

      </div>
    </DashboardLayout>
  );
};

export default AddHeroSection;